<template>
    <div>
        <div>
            <TitleBar :title="Localizer.Localize('ChooseTenant_Choose_Tenant')+' ('+UserName+')'">
                <template v-slot:right-group>
                    <input v-if="TenantsNotFiltered!=null && TenantsNotFiltered.length>5" type="text" v-model="filter" style="max-width:400px; float:right" placeholder="Filter" />
                    <div @click="toggleAlmView" tabindex="0" role="button" class="toggle-alm-btn" v-if="UserCanManageALM && isLandscapeManagementFeatureFlagEnabled">
                        <img src="../../public/icons/landscape/LifecycleManagementLogo.svg">
                        <span>{{Localizer.Localize("ModuleSecurityDetailsView_LandscapeManagement")}}</span>
                        <f-icon icon="chevronright"
                                :size="22"
                                color="primary" />
                    </div>
                </template>
            </TitleBar>
        </div>
        
        <transition name="fade" mode="out-in">
            <spinner v-if="displaySpinner"></spinner>

            <div v-else style="padding: 16px 24px">
                <p v-if="!hideFilterTenants" 
                    style="display: inline-flex; align-items: flex-end;">
                    <Checkbox v-model="filterTenants" /> &nbsp;
                    {{Localizer.FormatLocalize("ChooseTenant_Display_only_0_tenants", currentEnvironment)}}
                </p>
                <br />

                <div v-if="UserDoesNotHaveTenants">
                    <Empty>{{Localizer.Localize("ChooseTenant_You_don_t_have_access_to_any_tenants")}} ({{UserName}}).</Empty>
                    <template v-if="showSignInSignOut">
                        <CommonButton
                            :type="ButtonType.Primary"
                            :text="Localizer.Localize('ChooseTenant_LOGOUT')"
                            @click="Logout_Click"/>
                    </template>
                </div>

                <transition-group name="fso" tag="div" class="tenant-grid_v2">
                    <div v-for="(Tenant, i) in Tenants"
                        class="tenant_btn_v2"
                        @click="Tenant_Click(Tenant, $event)"
                        :key="Tenant.name"
                        :title="Tenant.name"
                        :style="{'--i':i/Tenants.length}">
                        <div v-if="GetImage(Tenant.name)!=null" style="width:0px; height:0px; position:absolute; margin-top: -200px; margin-left: -200px; overflow:visible">
                            <img :src="GetImage(Tenant.name)" style="width:200px; height:200px;" />
                        </div>
                        <img src="../../public/icons/santahat.png" style="z-index:1; position: absolute; margin-top: -30px; margin-left: -70px;" v-if="isChristmas" />
                        <div class="tenant-block-content-box">
                            <div class="tenant-block-text">
                                <span style="z-index: 1;">{{FormatTenantName(Tenant.name, Tenant.caption)}}</span>
                                <span style="z-index: 1; font-size: 14px; line-height: 17px; color:var(--accent-color5); font-weight: 400;" class="env">
                                    ({{Tenant.environment}})
                                </span>
                            </div>
                            <div class="tenant-block-icon" >
                                <CloudIcon :color="Tenant.bgColor ? Tenant.bgColor : 'var(--anaplan-background)'"/>
                            </div>
                        </div>
                    </div>

                <template v-if="showSignInSignOut">
                    <div class="tenant_btn_v2" v-if="!LoadingTenants"
                        @click="Logout_Click">
                        <div class="tenant-block-content-box">
                            <span style="z-index: 1;">Sign Out</span>
                        </div>
                    </div>

                    <div class="tenant_btn_v2" v-if="!LoadingTenants"
                        @click="SwitchUser_Click">
                        <div class="tenant-block-content-box">
                            <span style="z-index: 1;">Sign in as a different user</span>
                        </div>
                    </div>
                </template>

                </transition-group>            

                <RightPanel v-if="GenerateAiImageRightPanel" @close="GenerateAiImageRightPanel=false">
                    <template v-slot:header>
                    <div></div>
                    </template>
                    <template v-slot:footer>
                        <div class="panelButtons">
                            <CommonButton
                                :type="ButtonType.Default"
                                :text="Localizer.Localize('Cancel_PascalCase')"
                                @click="GenerateAiImageRightPanel=false"/>
                        </div>
                        <br />
                    </template>
                </RightPanel>
            </div>
        </transition>
    </div>
</template>
<script lang="ts">
    require('@/assets/portal.css');
    import { Component, Prop, Vue } from 'vue-facing-decorator';
    import { AuthClient } from "../api/ApiClientBase";
    import * as api from "../api/ApiClient";
    import { Localizer } from "../api/Localizer";
    import TitleBar from "./helpers/TitleBar.vue";
    import Spinner from "./helpers/Spinner.vue";
    import RightPanel from "./helpers/RightPanel.vue";
    import Empty from "./helpers/Empty.vue";
    import Checkbox from "./helpers/Checkbox.vue";
    import Confirm2 from "./helpers/Confirm2.vue";
    import { isFeatureFlagEnabled } from '@/services/featureFlagService';
    import CloudIcon from "./icons/CloudIcon.vue";
    import { AuthenticationProvider } from '@/api/IAuthenticationProvider';
    import CommonButton from "./helpers/CommonButton.vue";
    import { ButtonType } from "./helpers/HelpersInterface";
    import { isEmbedded } from '@/utils/Utils';

    @Component({ components: { Spinner, Empty, Checkbox, Confirm2, RightPanel, TitleBar, Localizer, CloudIcon, CommonButton } })
    export default class ChooseTenant extends Vue {
        private Localizer = new Localizer(this.$store);
        private ButtonType = ButtonType;
        private currentEnvironment: string = '';
        private embedded: boolean = isEmbedded();
        private filterTenants: boolean = false;
        private isChristmas = false;
        private filter: string = "";
        private isLandscapeManagementFeatureFlagEnabled: boolean = false;
        private limitTenantsToSameEnvFlag: boolean = false;
        private hideSignOutWhenEmbeddedFlag: boolean = false;
        private displaySpinner: boolean = true;
        private fixTenantSwitchModelsAsyncRaceFlag: boolean = false;

        get hideFilterTenants(): boolean {
            if (this.limitTenantsToSameEnvFlag && this.embedded) {
                return true;
            }
            return false;
        }

        get showSignInSignOut(): boolean {
            return !this.hideSignOutWhenEmbeddedFlag || !this.embedded;
        }

        get TenantsNotFiltered(): api.Tenant[] | null {
            this.isChristmas = (this.currentEnvironment == "Local" || this.currentEnvironment == "Dev") && new Date().getMonth() == 11;
            const tenants = this.$store.state.security.Tenants as (api.Tenant[] | null);

            let result: api.Tenant[] | null = [];
            if (tenants != null) {
                result = tenants!.filter(t => { return !this.filterTenants || t.environment?.toLowerCase() == this.currentEnvironment.toLowerCase() });
            }
            else
                result = tenants;

            return result;
        }

        get Tenants(): api.Tenant[] | null {

            var result = this.TenantsNotFiltered;

            if (result != null && this.filter != null && this.filter.length > 0)
                result = result!.filter(t => {
                    var ok = t.name!.toLowerCase().indexOf(this.filter.toLowerCase()) >= 0;
                    if (!ok && t.caption != null)
                        ok = this.Localizer.ParseLocalizedString(t.caption)!.toLowerCase().indexOf(this.filter.toLowerCase()) >= 0;
                    return ok;
                });

            return result;
        }


        get Tenant(): api.Tenant | null { return this.$store.state.security.Tenant; }
        get LoadingTenants(): boolean { return this.Tenants === null }
        get UserDoesNotHaveTenants(): boolean { return this.Tenants != null && this.Tenants.length === 0 }
        get UserName(): string { return this.$store.state.security.UserName; }

        get UserCanManageALM(): boolean {
            if (!this.Tenants) {
                return false;
            }
            return this.Tenants.some((element:api.Tenant) => element.isALMEnabled);
        }

        async ensureTenantSelected(): Promise<void> {
            const tenants = this.$store.state.security.Tenants as api.Tenant[] | null;
            if (this.Tenant == null && tenants != null && tenants.length === 1) {
                await this.$store.dispatch("security/SelectTenant", tenants[0]);
            }
        }

        private async Logout_Click(): Promise<void> {
            this.$store.dispatch("security/LogOut");
        }
        private async SwitchUser_Click(): Promise<void> {
            this.$store.dispatch("security/SwitchUser");
        }
        private async Tenant_Click(tenant: api.Tenant, e: MouseEvent): Promise<void> {
            if (e.ctrlKey) {
                this.SelectedTenant = tenant.name!;
                this.GenerateAiImageRightPanel = true;
            }
            else if (e.shiftKey) {
                await this.$store.dispatch("security/SelectTenant", tenant);
            }
            else {
                if (tenant.environment != this.currentEnvironment && tenant.portalUrl != null) {
                    const auth_client = AuthClient.getInstance();
                    let authQueryString = '';
                    if(auth_client.AuthProvider()?.getProviderType() === AuthenticationProvider.AUTH0) authQueryString = '&auth=auth0';
                    document.location.assign(tenant.portalUrl + "?tenant=" + tenant.name + authQueryString);
                }
                else
                    await this.$store.dispatch("security/SelectTenant", tenant);
            }
        }
        private async mounted() {
            this.isLandscapeManagementFeatureFlagEnabled = this.$store.state.security.AlmFeatureFlagValue;
            this.limitTenantsToSameEnvFlag = await isFeatureFlagEnabled("PHOS-2491_limitTenantsToSameEnv");
            if (this.hideFilterTenants) this.filterTenants = true;
            this.hideSignOutWhenEmbeddedFlag = await isFeatureFlagEnabled("PHOS-2729_hideSignOutWhenEmbedded");
            this.Localizer = new Localizer(this.$store);
            this.currentEnvironment = AuthClient.configuration.$config?.environment || '';
            var auth_client = AuthClient.getInstance();

            this.displaySpinner = false;
            this.fixTenantSwitchModelsAsyncRaceFlag = await this.$store.dispatch(
                "models/LoadFixTenantSwitchModelsAsyncRaceFlag"
            );
            if (!this.fixTenantSwitchModelsAsyncRaceFlag) {
                // Legacy path previously inside the TenantsNotFiltered getter
                await this.ensureTenantSelected();
            }
        }
        private FormatTenantName(name: string, caption: string) {
            if (caption != null)
                return this.Localizer.ParseLocalizedString(caption);
            name = name.replaceAll("_", " ");
            if (name.length < 10 || name.indexOf(' ') > 0)
                return name;
            else {
                return name.replace(/([a-z0-9])([A-Z])/g, '$1 $2')
            }
        }
        IsBusy: boolean = false;
        SelectedTenant = '';
        GenerateAiImageRightPanel: boolean = false;
        AiPrompt: string = "";
        AiUrl: string | null = "";
        private GetImage(tenantName: string): string | null {
            var tenantImage = TenantImage.TenantImages.find(t => t.TenantName == tenantName);
            if (tenantImage != null)
                return tenantImage.Image;
            else
                return null;
        }

        public toggleAlmView():void {
            this.$store.commit('alm/setAlmView', true);
        }
    }
    class TenantImage {
        public TenantName: string;
        public Image: string;
        static TenantImages: TenantImage[] = [];
        constructor(tenantName: string, image: string) {
            this.TenantName = tenantName;
            this.Image = image;
        }
    }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .header-bar {
        border-bottom: 1px solid var(--thin-border);
    }

    .tenant-grid_v2 {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(230px, 1fr)); 
        gap: 24px;
    }

    @media (min-width: 1200px) {
        .tenant-grid_v2 {
            grid-template-columns: repeat(5, 1fr);
        }
    }

    .tenant_btn_v2 {
        position: relative;
        width: auto;
        height: 125px;
        color: var(--accent-color5);
        background-color: var(--background-primary);
        box-shadow: 0 0 0 1px #242d4814, 0 2px 4px var(--anaplan-box-shadow);
        border: 1px solid var(--background-primary);
        border-radius: 2px;
        cursor: pointer;
        padding: 16px;
        overflow: auto;
        font-size: 16px;
        line-height: 19px;
        font-weight: 600;
        display: flex;
        flex-direction: column;
    }

    .tenant-block-content-box {
        display: flex;
        justify-content: space-between;
        height: 100%
    }

    .tenant-block-text {
        display: flex;
        flex-direction: column;
    }

    .tenant-block-icon {
        display: flex;
        width: 16px;
        height: 16px;
        align-self: flex-end;
    }

    .env {
        font-size: 15px;
        text-transform: capitalize;
    }

    .fso-leave-active {
    }

    .fso-enter-active {
        transition: all .3s ease;
        transition-delay: calc(0.500s * var(--i));
    }

    .fso-enter-from, .fso-leave-to {
        opacity: 0;
        transform: translateX(30px);
    }

    .toggle-alm-btn {
        display: flex;
        align-items: center;
        border-left: solid 1px var(--accent-color3);
        padding-left: 12px;
        margin-left: 12px;
        cursor: pointer;
    }

    .toggle-alm-btn span {
        font-size: 14px;
        margin-left: 8px;
        margin-right: 4px;
    }
</style>
